import React from 'react';
import {Route, Link} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import routes from '../../routes';

const findRouteName = (url, rArray) => {
  let route = null
  if (!rArray) {
    rArray = routes
  }
  for (let index = 0; index < rArray.length; index++) {
    const element = rArray[index];
    if (element.path == url) {
      route = element
    }
    else if (element.routes && element.routes.length > 0) {
      route = findRouteName(url, element.routes)
    }
    if (route) {
      break
    }
  }
  return route
};

const getPaths = (pathname) => {
  const paths = ['/'];

  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr, index) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

const BreadcrumbsItem = ({...rest, match}) => {
  const route = findRouteName(match.url);
  if (route) {
    return (
      match.isExact ?
        (
          <BreadcrumbItem active>{route.name}</BreadcrumbItem>
        ) :
        (
          <BreadcrumbItem>
            <Link to={match.url || ''}>
              {route.name}
            </Link>
          </BreadcrumbItem>
        )
    );
  }
  return null;
};

const Breadcrumbs = ({...rest, location : {pathname}, match}) => {
  const paths = getPaths(pathname);
  const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem}/>);
  return (
    <Breadcrumb>
      {items}
    </Breadcrumb>
  );
};

export default props => (
  <div>
    <Route path="/:path" component={Breadcrumbs} {...props} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js